import * as d3 from "d3";

export default class MinimalDistributionChart {
  #container: any;
  #nBinsForContinuousData = 30;
  #svg;
  #g;

  constructor(container: any) {
    this.#container = container;
    this.#svg = d3.select(container).select("svg");
    this.#g = this.#svg.append("g");
  }

  setData(data: any, isCategorical: boolean) {
    if (isCategorical) {
      this.#setCategoricalData(data);
    } else {
      this.#setContinuousData(data);
    }
  }

  #setContinuousData(data: any) {
    //i.e. given continuous data, produce bins _only_ for the distribution chart
    const that = this;

    const bbox = (that.#svg.node() as any).getBoundingClientRect();
    //produce some own equidistant threshold since d3 always does weird things with the nBins...
    var thresholds = [];
    const xExtent = d3.extent(data);
    //check if xExtent[0] is negative
    if (xExtent[0] && Number(xExtent[0]) < 0) {
      //Check which one is larger in absolute value
      var largestExtent = Math.max(
        Math.abs(Number(xExtent[0])),
        Math.abs(Number(xExtent[1]))
      );
      xExtent[0] = (-largestExtent).toString();
      xExtent[1] = largestExtent.toString();
    }

    var xScale = d3
      .scaleLinear()
      .domain(xExtent as any)
      .range([0, bbox.width]);

    // @ts-ignore
    if (xExtent[1] - xExtent[0] > 0) {
      // @ts-ignore
      var stepsize = (xExtent[1] - xExtent[0]) / that.#nBinsForContinuousData;
      for (
        // @ts-ignore
        var i = xExtent[0] + stepsize;
        // @ts-ignore
        i <= xExtent[1] - stepsize;
        i += stepsize
      )
        thresholds.push(i);
    }
    var histogram = d3
      .histogram()
      .value((d) => d)
      .domain(xScale.domain() as any)
      .thresholds(thresholds as any);

    // And apply this function to data to get the bins
    var bins = histogram(data);
    var yScale = d3
      .scaleLinear()
      .domain([0, d3.max(bins, (d) => d.length)] as any)
      .range([bbox.height, 0]);

    var update: any = that.#g.selectAll("rect").data(bins);
    var enter = update.enter().append("rect").attr("x", 1);
    update.exit().remove();
    enter
      .merge(update)
      .attr(
        "transform",
        (d: any) => `translate(${xScale(d.x0)} , ${yScale(d.length)})`
      )
      .attr("width", (d: any) => xScale(d.x1) - xScale(d.x0) - 1)
      .attr("height", (d: any) => bbox.height - yScale(d.length));
  }

  #setCategoricalData(data: any) {
    const that = this;
    const bbox: any = (this.#svg.node() as any).getBoundingClientRect();
    var xScale = d3
      .scaleBand()
      .range([0, bbox.width])
      .domain(data.map((d: any) => d.label))
      .padding(0.01);
    var yScale = d3
      .scaleLinear()
      // @ts-ignore
      .domain([0, d3.max(data, (d) => d.value)])
      .range([bbox.height, 0]);
    var update: any = that.#g.selectAll("rect").data(data);
    var enter = update.enter().append("rect");
    update.exit().remove();
    enter
      .merge(update)
      .attr("width", xScale.bandwidth())
      .attr("height", (d: any) => bbox.height - yScale(d.value))
      .attr(
        "transform",
        (d: any) => `translate(${xScale(d.label)} , ${yScale(d.value)})`
      );
  }

  clear() {
    this.#g.selectAll("rect").remove();
  }
}
